/**
 * Formats break duration as "30min", "1hr", or "1hr 30min"
 * @param breakDurationInMinutes - Break duration in minutes
 * @returns Formatted break duration string
 */
export function formatBreakDuration(breakDurationInMinutes: number): string {
  const breakHours = Math.floor(breakDurationInMinutes / 60);
  const breakMinutes = breakDurationInMinutes % 60;

  if (breakHours > 0 && breakMinutes > 0) {
    return `${breakHours}hr ${breakMinutes}min`;
  }

  if (breakHours > 0) {
    return `${breakHours}hr`;
  }

  return `${breakMinutes}min`;
}
